import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@store/auth';
import deviceInfo from '@store/deviceInfo';
import deviceSetting from '@store/deviceSetting';
import mypage from '@store/myPage';
import playList from '@store/playList';
import schedule from '@store/schedule';
import video from '@store/video';

Vue.use(Vuex);

const createStore = () => {
  return new Vuex.Store({
    modules: {
      auth,
      deviceInfo,
      deviceSetting,
      mypage,
      playList,
      schedule,
      video,
    },
  });
};

export default createStore();
